<!--<div class="pagebrk"></div>-->
<!--<div class=""></div>-->

  <div class="row">
    <div class="col-md-12 padding-left-0px padding-right-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">
          <div class="row">
            <div class="col-md-12 text-align-center padding-left-0px padding-right-0px">
              <label class="font-familyhead">{{TemplateName}}</label>
            </div>
          </div>

          <!--<div class="row bordertop border-bot-1px margin-left-0px margin-right-0px">
            <div class="col-md-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-family">Owner:</label>
                </div>
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-weight-bold font-family float-left">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-family">Gender/Age:</label>
                </div>
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-family float-left">{{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>


            </div>

            <div class="col-md-1"></div>

            <div class="col-md-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-family">Patient ID:</label>
                </div>
                <div class="col-md-6">
                  <label class="margin-bottom-0px font-family float-left">{{l.FormattedCode}}</label>
                </div>
              </div>
            </div>
          </div>-->

          <!--<div class="pagebrkauto"></div>-->
          <div *ngIf="fo && fo.AutoSections" class="bordertop">
            <div class="col-md-12 padding-left-0px padding-right-0px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12 padding-left-0px padding-right-0px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                  <div class="card background-color-wt margin-left-0px margin-right-0px margin-bottom-0px">  
                    <div>
                      <div [ngSwitch]="section.SectionType">
                        <div class="card-header background-color-wt font-familysubhead padding-left-0px padding-top-0px padding-bottom-0px padding-right-0px font-weight-normal2 card-header-bg">
                          <div class="row margin-left-0px margin-right-0px">
                            <div class="col-md-12 padding-left-0px padding-right-0px">
                              <label class="margin-bottom-0px font-familysubhead font-weight-bold">{{section.Data.Title}}</label>
                            </div>
                            <!--<div class="col-print-3">
                              <h5 class="mb-0">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                        aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                  {{section.Data.Title}}

                                </button>

                              </h5>
                            </div>
                            <div class="col-print-9">

                            </div>-->
                          </div>


                        </div>
                        <div>

                          <div class="card-body background-color-wt padding-bottom-0px padding-right-0px padding-top-0px">
                            <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'AttrVal'">
                              <div class="col-md-12 padding-left-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                <div [ngSwitch]="field.Data.ValueType">
                                  <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Bool'">
                                    <auto-gen-boolpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                   mode="view">
                                    </auto-gen-boolpv>
                                  </div>
                                  <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'List'">
                                    <auto-gen-listpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                   mode="view">
                                    </auto-gen-listpv>
                                  </div>
                                  <div class="row margin-top-0px margin-left-0px margin-right-0px" *ngSwitchCase="'Text'">
                                    <auto-gen-textpv class="col-md-12 padding-left-0px padding-right-0px" [field]="field.Data" mode="view"></auto-gen-textpv>
                                  </div>
                                  <div class="row margin-top-0px margin-left-0px margin-right-0px" *ngSwitchCase="'CVS'">
                                    <auto-gen-cvspv class="col-md-12 padding-left-0px padding-right-0px" [field]="field.Data" mode="view"></auto-gen-cvspv>
                                  </div>
                                  <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Date'">
                                    <auto-gen-datepv class="col-md-12 padding-left-0px padding-right-0px" [field]="field.Data" mode="view"></auto-gen-datepv>
                                  </div>
                                  <div class="row padding-bottom-0px margin-left-0px margin-right-0px" *ngSwitchCase="'Grid'">                                    
                                    <auto-gen-gridpv class="col-md-12 padding-left-0px padding-right-0px" [field]="field" mode="view"></auto-gen-gridpv>
                                  </div>

                                  <div class="row margin-left-0px margin-right-0px" *ngSwitchDefault>

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Text'">
                              <div class="col-md-12 padding-left-0px padding-right-0px">                               
                                <div class="row margin-left-0px margin-right-0px">
                                  <div class="col-md-12 padding-left-0px padding-right-0px" *ngFor="let field of section.Data.Fields">
                                    <div class="row margin-left-0px margin-right-0px" *ngIf="field.ValueType=='Text'">

                                      <div class="col-md-11 padding-left-0px padding-right-0px">

                                        <textarea class="border-all-0px font-family font-weight-normal size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [(ngModel)]="field.Value" maxlength="600"></textarea>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Image'">
                              <div class="col-md-12 padding-left-0px padding-right-0px">
                                <div class="row margin-left-0px margin-right-0px">
                                  <div class="col-md-12 padding-left-0px padding-right-0px">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <tbody class="table-body">

                                            <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                
                                              <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                              <td class="padding-top-0px padding-bottom-0px ">
                                                <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                              </td>
                                              <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                <div *ngIf="field.HasImage">
                                                  <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='noimage.png';">
                                                  <!--<label class="margin-bottom-0px">No Image</label>-->
                                                </div>
                                              </td>

                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family">Surgeon</label>
            </div>
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
          </div>-->



        </div>

      </div>

    </div>
  </div>


<!--<printfooterview></printfooterview>-->
